import { render, staticRenderFns } from "./application-installment2.vue?vue&type=template&id=2a73749b&"
import script from "./application-installment2.vue?vue&type=script&lang=js&"
export * from "./application-installment2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Baner: require('/var/www/components/baner/baner.vue').default,BenefitsSlider: require('/var/www/components/benefits/benefits-slider.vue').default,FormInstallment2: require('/var/www/components/form/form-installment2.vue').default,FormInstallment2Desktop: require('/var/www/components/form/form-installment2-desktop.vue').default})
